import React from 'react';
import PropTypes from 'prop-types';
import getText from 'context/language/getText';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { useStyles } from './styled';

export const SuspendedPaymentMethod = ({ user }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push(urlConstructor(urlMap.MY_INFO, { id: user.id }));
  };

  return (
    <div>
      <BodyLarge className={classes.error}>
        {getText('banners.suspendedPaymentMethod.title')}
      </BodyLarge>
      <BodyRegular className={classes.error}>
        {getText('banners.suspendedPaymentMethod.body')}
        <Button variant="text" style={{ padding: 0 }} onClick={handleClick}>
          {getText('banners.suspendedPaymentMethod.action')}
        </Button>
      </BodyRegular>
    </div>
  );
};

SuspendedPaymentMethod.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    paymentMethods: PropTypes.array
  }).isRequired
};
